/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const MultiValueLabel = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.MultiValueLabel;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

MultiValueLabel.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      MultiValueLabel: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

MultiValueLabel.defaultProps = {
  selectProps: {
    custom: {
      MultiValueLabel: null,
    },
  },
  children: null,
};

export default MultiValueLabel;
